import React from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import CDInput from 'components/cd-input'
import TextArea from 'components/text-area'
import CDImage from 'components/cd-image-upload'
import CDButton from 'components/cd-button'
import NativeSelect from '../components/native-select'
import { dealsApi } from '../restaurant.api'
import { useDeals } from './deals.context'

const TYPE_OPTIONS = [
  { value: 'combo', label: 'Combo' },
  { value: 'special_offer', label: 'Special Offer' },
  { value: 'discount', label: 'Discount' },
]

const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
]

const validationSchema = Yup.object({
  name: Yup.string().required('Deal name is required'),
  price: Yup.number()
    .typeError('Price must be a number')
    .min(0, 'Price cannot be negative')
    .nullable(),
})

const toInitialValues = (deal) => ({
  name: deal?.name || '',
  description: deal?.description || '',
  price: deal?.price ?? '',
  oldPrice: deal?.oldPrice ?? '',
  tag: deal?.tag || '',
  type: deal?.type || 'combo',
  status: deal?.status || 'active',
  image: deal?.image || '',
})

function DealForm({ deal, onClose }) {
  const { refresh } = useDeals()
  const isEditing = !!deal?._id

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = {
      ...values,
      price: values.price === '' ? undefined : Number(values.price),
      oldPrice: values.oldPrice === '' ? undefined : Number(values.oldPrice),
    }
    delete payload.imageName

    const { response } = isEditing
      ? await dealsApi.update(deal._id, payload)
      : await dealsApi.create(payload)

    setSubmitting(false)
    if (response?.success) {
      await refresh()
      onClose()
    }
  }

  return (
    <Formik
      initialValues={toInitialValues(deal)}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formik) => (
        <Form className='tw-flex tw-flex-col tw-gap-4'>
          <CDInput name='name' label='Deal name' required />
          <TextArea name='description' label='Description' />
          <div className='tw-flex tw-gap-4'>
            <CDInput name='price' label='Price' type='number' />
            <CDInput name='oldPrice' label='Old price' type='number' />
          </div>
          <CDInput name='tag' label='Tag' />
          <NativeSelect name='type' label='Type' options={TYPE_OPTIONS} />
          <NativeSelect name='status' label='Status' options={STATUS_OPTIONS} />
          <CDImage name='image' label='Deal image' />

          <div className='tw-flex tw-gap-3 tw-mt-2'>
            <CDButton
              type='submit'
              processing={formik.isSubmitting}
              label={isEditing ? 'Save changes' : 'Create deal'}
            />
            <button
              type='button'
              onClick={onClose}
              className='tw-px-[24px] tw-py-[8px] tw-rounded-[6px] tw-border tw-border-gray-300 tw-text-gray-600 tw-text-regular'
            >
              Cancel
            </button>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default DealForm
